import React from 'react';

/* Drawn inline rather than pulled from an icon package: there are two of them,
 * and they inherit currentColor so they recolour with the thing they sit in. */

export const SearchIcon = ({ size = 15 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    aria-hidden="true"
  >
    <circle cx="7" cy="7" r="4.6" />
    <path d="M10.4 10.4 14 14" />
  </svg>
);

/* The favicon, as a component: two cubics meeting at a horizontal tangent with
 * the point of inflection marked. Kept in step with frontend/scripts/
 * render_favicons.py by hand - it is four numbers, and generating a React file
 * from the renderer would cost more than it saves. */
export const Mark = () => (
  <svg className="tw-mark" viewBox="4 6 24 20" fill="none" aria-hidden="true">
    <path
      d="M5.2 24.6 C 10 16, 12 16, 16 16 C 20 16, 22 16, 26.8 7.4"
      stroke="currentColor"
      strokeWidth="2.05"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="16" cy="16" r="3.45" fill="currentColor" />
  </svg>
);
